
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 982.5 982.5","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"recolor",attrs:{"d":"M948.2 423.3c-31.7-23.4-43-65.6-27.3-101.7 22.8-52.1-11.4-111.3-67.9-117.6-39.2-4.4-70.1-35.3-74.5-74.5C772.3 73 713 38.8 660.9 61.6c-36.1 15.8-78.3 4.5-101.7-27.3-33.7-45.8-102.1-45.8-135.8 0-23.4 31.7-65.6 43-101.7 27.3C269.5 38.8 210.3 73 204 129.5c-4.4 39.2-35.3 70.1-74.5 74.5-56.5 6.3-90.7 65.6-67.9 117.6 15.8 36.1 4.5 78.3-27.3 101.7-45.8 33.7-45.8 102.1 0 135.8 31.7 23.4 43 65.6 27.3 101.7C38.8 713 73 772.3 129.5 778.6c39.2 4.4 70.1 35.3 74.5 74.5 6.3 56.5 65.6 90.7 117.6 67.9 36.1-15.8 78.3-4.5 101.7 27.3 33.7 45.8 102.1 45.8 135.8 0 23.4-31.7 65.6-43 101.7-27.3 52.1 22.8 111.3-11.4 117.6-67.9 4.4-39.2 35.3-70.1 74.5-74.5 56.5-6.3 90.7-65.6 67.9-117.6-15.8-36.1-4.5-78.3 27.3-101.7 45.9-33.8 45.9-102.2.1-136z","fill":"#00bcd6"}}),_c('path',{staticClass:"st1",attrs:{"d":"M297.4 359.1l42.6 42.6 283.4 283.5 60.1-60.1L356 297.6z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M359.1 683.5l42.6-42.6 283.5-283.4-60.1-60.1-327.5 327.5z"}}),_c('g',[_c('path',{staticClass:"st1",attrs:{"d":"M491.3 857.7c-97.9 0-189.9-38.1-259.1-107.3S124.9 589.1 124.9 491.3 163 301.4 232.2 232.2s161.2-107.3 259.1-107.3S681.2 163 750.4 232.2s107.3 161.2 107.3 259.1-38.1 189.9-107.3 259.1c-69.2 69.2-161.3 107.3-259.1 107.3zm0-683.4c-84.7 0-164.3 33-224.1 92.8-59.9 59.9-92.8 139.5-92.8 224.1 0 84.7 33 164.3 92.8 224.1 59.9 59.9 139.5 92.8 224.1 92.8 84.7 0 164.3-33 224.1-92.8 59.9-59.9 92.8-139.5 92.8-224.1 0-84.7-33-164.3-92.8-224.1-59.9-59.8-139.5-92.8-224.1-92.8z"}})])])
          )
        }
      }
    